module.exports = __webpack_public_path__ + "static/img/icon-eva-zan.3c9430b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-eva-zan.png
// module id = 9MI4
// module chunks = 21